import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  sectionContent: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: theme.spacing(3),
    gap: theme.spacing(3),
  },
  planCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    backgroundColor: theme.palette.bg.main,
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.dividerV2.main}`,
    padding: theme.spacing(3),
  },
  emptyState: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(4),
    fontSize: '14px',
    lineHeight: '20px',
    color: theme.palette.labraText.description,
  },
  divider: {
    color: theme.palette.dividerV2.main,
  },
  subHeading: {
    fontSize: '16px',
    fontWeight: 500,
    color: theme.palette.labraText.primary,
    lineHeight: '24px',
  },
}))
